import { render, staticRenderFns } from "./EditDialogFooter.vue?vue&type=template&id=1c8b9c82"
import script from "./EditDialogFooter.vue?vue&type=script&lang=js"
export * from "./EditDialogFooter.vue?vue&type=script&lang=js"
import style0 from "./EditDialogFooter.vue?vue&type=style&index=0&id=1c8b9c82&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports